import { mockCustomerList, mockCustomerPlantList } from '@/mock/mockData'

function ok(data) {
  return Promise.resolve({ success: true, data })
}

// score url
export function getCustomerList() {
  return ok({ list: mockCustomerList() })
}

// 获取客户工厂列表
export function getCustomerPlantList() {
  return ok(mockCustomerPlantList())
}
